// Property PMS Type Section - Select Yardi or Entrata
import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { FormSection } from '@/components/common/admin/form';
import { PMSType } from '@/types/admin/properties';
import { ADMIN_COLORS } from '@/constants/admin';

interface PropertyPMSTypeSectionProps {
  pmsType: PMSType;
  onPmsTypeChange: (value: PMSType) => void;
  disabled?: boolean;
}

export const PropertyPMSTypeSection: React.FC<PropertyPMSTypeSectionProps> = ({
  pmsType,
  onPmsTypeChange,
  disabled,
}) => {
  const options: { value: PMSType; label: string }[] = [
    { value: 'yardi', label: 'Yardi' },
    { value: 'entrata', label: 'Entrata' },
  ];

  return (
    <FormSection title="Property Management System">
      <View style={styles.container}>
        <Text style={styles.label}>PMS Type *</Text>
        <Text style={styles.helpText}>Select your property management system</Text>
        
        <View style={styles.optionsContainer}>
          {options.map((option) => (
            <TouchableOpacity
              key={option.value}
              style={[
                styles.option,
                pmsType === option.value && styles.optionSelected,
                disabled && styles.optionDisabled,
              ]}
              onPress={() => !disabled && onPmsTypeChange(option.value)}
              disabled={disabled}
            >
              <View style={[
                styles.radio,
                pmsType === option.value && styles.radioSelected,
              ]}>
                {pmsType === option.value && <View style={styles.radioDot} />}
              </View>
              <Text style={[
                styles.optionLabel,
                pmsType === option.value && styles.optionLabelSelected,
              ]}>
                {option.label}
              </Text>
            </TouchableOpacity>
          ))}
        </View>
      </View>
    </FormSection>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 16,
  },
  label: {
    fontSize: 14,
    fontWeight: '600',
    color: ADMIN_COLORS.TEXT.PRIMARY,
    marginBottom: 4,
  },
  helpText: {
    fontSize: 12,
    color: ADMIN_COLORS.TEXT.SECONDARY,
    marginBottom: 12,
  },
  optionsContainer: {
    flexDirection: 'row',
    gap: 12,
  },
  option: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12,
    borderRadius: 8,
    borderWidth: 2,
    borderColor: ADMIN_COLORS.BORDER,
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
  },
  optionSelected: {
    borderColor: ADMIN_COLORS.PRIMARY,
    // backgroundColor: ADMIN_COLORS.PRIMARY,
  },
  optionDisabled: {
    opacity: 0.5,
  },
  radio: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: ADMIN_COLORS.BORDER,
    marginRight: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  radioSelected: {
    borderColor: ADMIN_COLORS.PRIMARY,
  },
  radioDot: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: ADMIN_COLORS.PRIMARY,
  },
  optionLabel: {
    fontSize: 14,
    color: ADMIN_COLORS.TEXT.PRIMARY,
    fontWeight: '500',
  },
  optionLabelSelected: {
    color: ADMIN_COLORS.PRIMARY,
    fontWeight: '600',
  },
});


